<div id="dialog-container">
  <mat-dialog-content class="fx-flex-auto" [formGroup]="organizationForm">
    <h1 mat-dialog-title>{{ 'TITLE.DUPLICATE_ORGANIZATION' | translate }}</h1>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'LABEL.ORGANIZATION_NAME' | translate }}</mat-label>
      <input formControlName="name" [id]="'duplicate_organization_name'" matInput
        required/>
      @if (organizationForm.controls.name.hasError('required')) {
        <mat-error>
          {{ 'ERROR.FIELD_REQUIRED' | translate }}
        </mat-error>
      }
      @if (organizationForm.controls.name.hasError('maxlength')) {
        <mat-error>
          {{ 'ERROR.FIELD_MAX_LENGTH' | translate:{value: appConfig.NAME_MAX_LENGTH} }}
        </mat-error>
      }
      @if (organizationForm.controls.name.hasError('isValueTaken')) {
        <mat-error>
          {{ 'ERROR.ORGANIZATION_NAME_ALREADY_IN_USE' | translate }}
        </mat-error>
      }
    </mat-form-field>
    <div class="config-tb-container">
      <mat-checkbox formControlName="withData">
        {{ 'LABEL.ORGANIZATION_DATA' | translate }}
      </mat-checkbox>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button matDialogClose>{{ 'BUTTON.CANCEL' | translate }}</button>
    <button [disabled]="!organizationForm.valid" [id]="'duplicate-organization-yes-button'" color="accent"
      mat-raised-button
      matDialogClose="yes">{{ 'BUTTON.ADD' | translate }}
    </button>
  </mat-dialog-actions>
</div>
